<template>
  <div :class="wrpCls">
    <notice-icon style="cursor: pointer; padding: 0 10px" v-if="onMounted"/>
<!--    <a-icon type="question-circle" theme="filled" style="cursor: pointer;padding: 0 10px"/>-->
    <avatar-dropdown :menu="showMenu" :current-user="{name: userName}" :class="prefixCls" />
    <!--    <select-lang :class="prefixCls" />-->
  </div>
</template>

<script>
import AvatarDropdown from './AvatarDropdown'
// import SelectLang from '@/components/SelectLang'
import NoticeIcon from '@/components/NoticeIcon/NoticeIcon'

export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
    // SelectLang,
    NoticeIcon
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action'
    },
    isMobile: {
      type: Boolean,
      default: () => false
    },
    topMenu: {
      type: Boolean,
      required: true
    },
    theme: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showMenu: true,
      // currentUser: {},
      onMounted: false
    }
  },
  computed: {
    wrpCls () {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${(this.isMobile || !this.topMenu) ? 'light' : this.theme}`]: true
      }
    },
    userName () {
      return this.$store.getters.userInfo.userName || '-'
    }
  },
  mounted () {
    // setTimeout(() => {
    //   this.currentUser = {
    //     name: 'Serati Ma'
    //   }
    this.onMounted = true
    // }, 1500)
  }
}
</script>
